import React, { useRef } from "react";
import { HiOutlineSearch } from "react-icons/hi";
import { VscChromeClose } from "react-icons/vsc";

const SearchInput2 = (props) => {
  const {
    type,
    placeholder,
    stateData,
    setStateData,
    width,
    parameter1,
    parameter2,
    addParam,
    resetParam,
  } = props;

  const searchRef = useRef(null);
  const handleChange = () => {
    var matches = searchRef.current?.value.match(/[A-z]/g);

    if (!matches) {
      setStateData({
        ...stateData,
        q: `${parameter1}:${searchRef.current.value}`,
        page: 1,
      });
    } else {
      if (parameter2) {
        setStateData({
          ...stateData,
          q: `${parameter2}:${searchRef.current.value}`,
          page: 1,
        });
      } else {
        setStateData({
          ...stateData,
          q: `${parameter1}:${searchRef.current.value}`,
          page: 1,
        });
      }
    }
  };

  return (
    <>
      <div className="searchWrapper" style={{ width: width }}>
        <div className="w-100">
          <input
            ref={searchRef}
            type={type}
            className="form-control shadow-none"
            autoComplete="off"
            placeholder={placeholder}
            // defaultValue={stateData?.q ? stateData?.q : ""}
            value={stateData?.q ? stateData?.q.split(":")[1] : ""}
            onChange={handleChange}
          />
        </div>
        {!stateData.show ? (
          <div
            className="searchBtn"
            onClick={() => {
              addParam();
              setStateData({
                ...stateData,
                show: true,
              });
            }}
          >
            <HiOutlineSearch />
          </div>
        ) : (
          <div
            className="crossBtn"
            onClick={() => {
              resetParam();
              setStateData({
                show: false,
              });
            }}
          >
            <VscChromeClose />
          </div>
        )}
      </div>
    </>
  );
};

export default SearchInput2;
